module.exports = __webpack_public_path__ + "static/media/three.3fe2ec1b.svg";